module.exports = __webpack_public_path__ + "salesforce.b5c984dbadf007e1896868b98055a701.svg";